<div class="accordion">
  @for (section of sections; track section.title; let sectionIndex = $index) {
    <div class="accordion-item">
      <h2 class="accordion-header" [id]="'heading-' + sectionIndex">
        <button
          class="accordion-button"
          type="button"
          data-gtmaction="event_view_more_details"
          data-gtmcategory="event_informational_action"
          [attr.data-gtmlabel]="section.title"
          [ngClass]="{ collapsed: !section.active }"
          [attr.aria-expanded]="section.active"
          [attr.aria-controls]="'collapse-' + sectionIndex"
          (click)="setActiveItem(section); gtmEvent($event)"
        >
          {{ section.title }}
        </button>
      </h2>
      <div
        class="accordion-collapse collapse"
        [id]="'collapse-' + sectionIndex"
        [ngClass]="{ show: section.active }"
        [attr.aria-labelledby]="'heading-' + sectionIndex"
        [attr.data-testid]="'section-content-' + sectionIndex"
      >
        <div class="accordion-body" [innerHTML]="section.content"></div>
      </div>
    </div>
  }
</div>
